<template>
	<!-- 导航跳转有bug -->
	<div class="case_wrap">
		<el-container v-if='$route.query.typeId != undefined'>
			<el-aside width="250px">
				<el-menu default-active="ComAwait" router>
					<p @click="pathFun" class="b_index">返回首页</p>
					
           <!-- 救援 -->
           <div class="nav_box" v-if="typeId==900" >
						<a class="up">救援案件</a>
						<!--<router-link class="up" :to="{name:'ComAwait',params:{token:token},query:{typeId:typeId}}">星使派单</router-link>-->
						<router-link  class="ha" :to="{name:'createRescue',params:{token:token},query:{typeId:typeId}}">创建案件</router-link>
						<!-- <a v-if='insti.type != 5' class="up">星使派单处理</a> -->
            <router-link  class="ha" :class='{active:routerShow7}' :to="{name:'rescueList',params:{token:token},query:{typeId:typeId,type:4}}">全部案件</router-link>
            <router-link  class="ha" :class='{active:routerShow6}' :to="{name:'rescueList',params:{token:token},query:{typeId:typeId,type:0}}">待处理案件</router-link>
            <router-link  class="ha" :class='{active:routerShow4}' :to="{name:'rescueList2',params:{token:token},query:{typeId:typeId,type:1}}">救援中</router-link>
						<router-link  class="ha" :class='{active:routerShow1}' :to="{name:'rescueList3',params:{token:token},query:{typeId:typeId,type:2}}">已完成案件</router-link>
            <router-link class="ha" :class='{active:routerShow5}'  :to="{name:'rescueList4',params:{token:token},query:{typeId:typeId,type:3}}">已取消案件</router-link>
            <router-link class="ha" :class='{active:routerShow3}' :to="{name:'Insurancemanagement',params:{token:token},query:{typeId:typeId}}">保险机构管理</router-link>
					</div>
           <!-- 家财险 -->
          	<div class="nav_box" v-else-if="typeId == 800" >
						<a class="up">家财服务</a>
						<!--<router-link class="up" :to="{name:'ComAwait',params:{token:token},query:{typeId:typeId}}">星使派单</router-link>-->
						<router-link  class="ha" :to="{name:'Familywealth',params:{token:token},query:{typeId:typeId}}">创立案件</router-link>
						<!-- <a v-if='insti.type != 5' class="up">星使派单处理</a> -->
            	<router-link  class="ha" :class='{active:routerShow6}' :to="{name:'Homestart4',params:{token:token},query:{typeId:typeId}}">全部案件管理</router-link>
            	<router-link  class="ha" :class='{active:routerShow4}' :to="{name:'Homestart2',params:{token:token},query:{typeId:typeId}}">未启动救援案件管理</router-link>
						<router-link  class="ha" :class='{active:routerShow1}' :to="{name:'Homestart',params:{token:token},query:{typeId:typeId,t:1}}">已启动救援案件管理</router-link>
            <router-link class="ha" :class='{active:routerShow5}'  :to="{name:'Homestart3',params:{token:token},query:{typeId:typeId,t:0}}">救援完成待确认</router-link>
						<router-link class="ha" :class='{active:routerShow2}'  :to="{name:'Homestart1',params:{token:token},query:{typeId:typeId}}">已完成救援案件管理</router-link>
            			<router-link class="ha" :class='{active:routerShow10}'  :to="{name:'draft',params:{token:token},query:{typeId:typeId}}">草稿列表</router-link>
            <router-link class="ha" :class='{active:routerShow3}' :to="{name:'Insurancemanagement',params:{token:token},query:{typeId:typeId}}">保险机构管理</router-link>
					
					</div>
          <div class="nav_box" v-else>
						<router-link class="up" :to="{name:'ComAwait',params:{token:token},query:{typeId:typeId}}">{{typeName}}</router-link>
						<!-- <router-link :to="{name:'ComIndex',params:{token:token,insti:insti}}" class="b_index">返回首页</router-link> -->
						<router-link class="ha" :to="{name:'appcase',params:{token:token},query:{typeId:typeId}}">创建案件</router-link>
						<router-link class="up" :to="{name:'ComAwait',params:{token:token},query:{typeId:typeId}}">{{typeName}}管理</router-link>
						<router-link class="ha" :class='{active:routerShow1 || routerShow5}' :to="{name:'ComAwait',params:{token:token},query:{typeId:typeId}}">未启动救援案件列表</router-link>
						<router-link class="ha" :class='{active:routerShow2 || routerShow6 || routerShow7}'  :to="{name:'ComOffer',params:{token:token},query:{typeId:typeId}}">已启动救援案件管理</router-link>
						<router-link class="ha" :class='{active:routerShow4}' :to="{name:'ComRescue',params:{token:token},query:{typeId:typeId}}">救援中案件管理</router-link>
						<router-link class="ha" :class='{active:routerShow3}' :to="{name:'finishSure',params:{token:token},query:{typeId:typeId}}">救援完成待确认</router-link>
						<router-link class="ha" :class='{active:routerShow8}' :to="{name:'finishEnd',params:{token:token},query:{typeId:typeId}}">已完成案件</router-link>
						<router-link class="ha" :class='{active:routerShow9}' :to="{name:'ComAwait1',params:{token:token},query:{typeId:typeId}}">报价被拒案件</router-link>
					</div>
				</el-menu>
			</el-aside>
			<el-main>
				<router-view></router-view>
			</el-main>
		</el-container>
		<el-container v-else>
			<el-aside width="250px">
				<el-menu default-active="ComAwait" router>
					<p @click="pathFun" class="b_index">返回首页</p>
					<div class="nav_box">
						<a>案件管理</a>
						<router-link class="active" :to="{name:'finishEnd'}">已完成救援案件列表</router-link>
						<!--<router-link :class='{active:routerShow5}' class="ha" :to="{name:'statistical'}">案件统计</router-link>-->
					</div>
				</el-menu>
			</el-aside>
			<el-main>
				<router-view></router-view>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import "isomorphic-fetch";
	import constants from '@/util/constants.js';
	import Promise from 'promise-polyfill';

	if(!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		data() {
			return {
				token: this.$route.params.token || JSON.parse(window.localStorage.getItem("data")).data,
				insti: this.$route.params.insti || JSON.parse(window.localStorage.getItem("insti")),
				typeId: this.$route.query.typeId,
				typeName: "",
				routerShow1:false,
				routerShow2:false,
				routerShow3:false,
				routerShow4:false,
				routerShow5:false,
				routerShow6:false,
				routerShow7:false,
				routerShow8:false,
				routerShow9:false,
        routerShow10:false
			};
		},
		methods: {
			back() {},
			pathFun(){
				this.$router.push({name:'mainPaseCmdcenter'})
			},
			routerFun(to){
				var router=to.name;
        console.log(router);
        console.log(to.query.sure)
				this.routerShow1=false;
				this.routerShow2=false;
				this.routerShow3=false;
				this.routerShow4=false;
				this.routerShow5=false;
				this.routerShow6=false;
				this.routerShow7=false;
				this.routerShow8=false;

				if(router == 'helpStart'){
					this.routerShow1=true;
				} else if(router == 'helpCompany' ){
					this.routerShow2=true;
				}else if(router == 'Comresstep' && to.query.sure){
          console.log('999')
          if( to.query.typeId == 800) {
               this.routerShow5 = true
          }else {
              	this.routerShow3=true;
          }
          if(to.query.typeId == 900) {
            this.routerShow6=true
          }
				
				}else if(router == 'Comresstep' && to.query.sure == undefined){
					this.routerShow4=true;
				}else if(router == 'ComParinf' && to.query.backto == '0' ){
					this.routerShow5=true;
				}else if(router == 'ComParinf' && to.query.backto == undefined){
					this.routerShow6=true;
				}else if(router == 'Comlookinf' || router == 'ComPar'){
					this.routerShow7=true;
				}else if(router == 'finishDetails'){
					this.routerShow8=true;
				}
			},
		},
		mounted() {
			let that = this;
			if(this.$route.query.typeId != undefined){
				fetch(constants.domain + "rescue/service_plan/get_service", {
					method: "POST",
					body: `token=${this.token ||
	            JSON.parse(window.localStorage.getItem("data"))
	              .data}&id=${this.typeId}`,
					mode: "cors",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded"
					}
				}).then(function(res) {
					return res.json();
				}).then(function(data) {
					if(data.code == 0) {
						that.typeName = data.obj.name;
					} else {
						console.log("center case index getService error:" + data.code);
					}
				})
			}
			this.routerFun(this.$route)
		},
		updated() {
			this.typeId = this.$route.query.typeId;
		},
		watch:{
			$route(to){
				this.routerFun(to)
			}
		}
	};
</script>

<style scoped>
	@import url(../../css/caseindex.css);
	.active{background: #00abfa;color: #fff;}
	.router-link-active:hover,
	.active:hover {
		color: #fff;
		background: #00abfa
	}

</style>



// WEBPACK FOOTER //
// src/components/cmd_center/Caseindex.vue